import { useState, useEffect } from 'react';
import { getAccountDetails, getSubscriptionDetails } from '../../../api/settings';
import { Box, Button, Typography } from '@mui/material';
import FormField from '../../../components/FormField';
import RequestUnitsModal from './RequestUnitsModal';
import SubscriptionHistoryModal from './SubscriptionHistoryModal';
import AmendBalanceModal from './AmendBalanceModal';
import { isEORIUser, is360PayStaff } from '../../../utils/roles';

const Subscription = ({ companyId, isVisible }) => {
  const [accountDetails, setAccountDetails] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [isRequestUnitsModalOpen, setIsRequestUnitsModalOpen] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [isAmendBalanceModalOpen, setIsAmendBalanceModalOpen] = useState(false);

  useEffect(() => {
    if (companyId && isVisible) {
      getAccountDetails(companyId).then((data) => {
        setAccountDetails(data);
      });

      getSubscriptionDetails(companyId).then((data) => {
        setSubscriptionDetails(data[0]);
      });
    }
  }, [companyId, isVisible]);

  return (
    <>
      <RequestUnitsModal
        isOpen={isRequestUnitsModalOpen}
        setIsOpen={setIsRequestUnitsModalOpen}
        companyId={companyId}
      />

      <SubscriptionHistoryModal isOpen={isHistoryModalOpen} setIsOpen={setIsHistoryModalOpen} companyId={companyId} />
      <AmendBalanceModal
        isOpen={isAmendBalanceModalOpen}
        setIsOpen={setIsAmendBalanceModalOpen}
        companyId={companyId}
        currentBalance={subscriptionDetails?.balance || 0}
        setBalance={(value) => setSubscriptionDetails((prev) => ({ ...prev, balance: value }))}
      />

      <Box className="account-settings">
        <FormField label="Company Name" value={accountDetails?.company} readOnly />
        <FormField label="EORI Number" value={accountDetails?.eori} readOnly />
        <FormField label="VAT Number" value={accountDetails?.vatNumber} readOnly />
        <FormField
          label="Balance"
          value={subscriptionDetails?.balance || '0'}
          tooltip="This balance may not include any declarations that are currently 'In Progress'"
          readOnly
        />

        <FormField label="Customer Actions" readOnly>
          <Box sx={{ display: 'flex', gap: 4 }}>
            <Button variant="outlined" onClick={() => setIsRequestUnitsModalOpen(true)}>
              Request Additional Units
            </Button>
            <Button variant="outlined" onClick={() => setIsHistoryModalOpen(true)}>
              View History
            </Button>
          </Box>
        </FormField>

        {isEORIUser() && !is360PayStaff() && (
          <FormField label="EORI Actions" readOnly>
            <Box sx={{ display: 'flex', gap: 4 }}>
              <Button variant="outlined" onClick={() => setIsAmendBalanceModalOpen(true)}>
                Amend Balance
              </Button>
            </Box>
          </FormField>
        )}

        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" className="field-label" sx={{ mb: 2 }}>
            Payment Details
          </Typography>

          <FormField label="Payment Contact" value={accountDetails?.paymentContactName} readOnly />
          <FormField label="Payment Contact Email" value={accountDetails?.paymentContactEmail} readOnly />
          <FormField label="Payment Contact Phone" value={accountDetails?.paymentContactPhone} readOnly />
          <FormField label="Customer Reference" value={accountDetails?.customerReference} readOnly />
        </Box>
      </Box>
    </>
  );
};

export default Subscription;
